import {useQuery} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";

const apiUrl = "api/power-station/instant-data";

const fetchPowerStationInstantData = async (powerStationId: number) => {
    try {
        const response = await axios.get(`${apiUrl}/${powerStationId}`);

        return {
            data: response.data.data,
            status: response.status
        }
    } catch (error) {
        // @ts-ignore
        console.error("Error fetching data:", error);
        throw new Error("dados não encontrados");
    }
};

export const FindInstantDataByPowerStationReactQuery = (powerStationId:number, refetchTime: number = 10000) => {
    const { enqueueSnackbar } = useSnackbar();
    return useQuery({
        queryKey: ['power-station-instant-data', powerStationId],
        queryFn: () => fetchPowerStationInstantData(powerStationId),
        onError: (error: any) => {
            enqueueSnackbar(`Erro ao carregar dados instantâneos : ${error.message}`, { variant: "error" });
        },
        enabled: powerStationId !== undefined,
        refetchInterval: refetchTime,
    })
};